import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import RawButton from '@material-ui/core/Button';
import CircularProgress from './CircularProgress';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none',
  },
  label: {
    fontSize: 14,
    fontFamily: 'Roboto',
    textTransform: 'none',
    fontWeight: 600,
  },
  buttonLoading: {
    width: 84,
    height: 36,
  },
  progress: {
    position: 'absolute',
    color: 'white',
    width: '20px !important',
    height: '20px !important',
  },
}));

const Button = React.forwardRef((props, ref) => {
  const { children, loading = false, progressClass, className, ...other } = props;
  const classes = useStyles();
  return (
    <RawButton 
      {...other}
      ref={ref}
      className={clsx({ [classes.buttonLoading]: loading }, classes.root, className )}
      classes={{ label: classes.label, ...other.classes }}
      color="primary"
    >
      {loading ? <CircularProgress show className={clsx(classes.progress, progressClass)} /> : children}
    </RawButton>
  );
});

Button.displayName = 'Button';

Button.propTypes = {
  loading: PropTypes.bool,
  progressClass: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.jsx